import { useEffect, useState } from "react";
import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Overview from "@/pages/home/components/Overview";
import Format from "@/pages/home/components/Format";
import WordCopyright from "@/pages/home/components/WordCopyright";
import Review from "@/pages/home/components/Review";
import Process from "@/pages/home/components/Process";
import Submit from "@/pages/home/components/Submit";
import Faq from "@/pages/home/components/Faq";
import Footer from "@/pages/home/components/Footer";

function BackToTop() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="返回顶部"
      className={`fixed bottom-6 right-6 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-all duration-300 hover:bg-primary-600 ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
      }`}
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </button>
  );
}

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Overview />
        <Format />
        <WordCopyright />
        <Review />
        <Process />
        <Submit />
        <Faq />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}